import { render, staticRenderFns } from "./UDIOutlist.vue?vue&type=template&id=72540ef9&scoped=true"
import script from "./UDIOutlist.vue?vue&type=script&lang=js"
export * from "./UDIOutlist.vue?vue&type=script&lang=js"
import style0 from "./UDIOutlist.vue?vue&type=style&index=0&id=72540ef9&prod&scoped=true&lang=css"
import style1 from "./UDIOutlist.vue?vue&type=style&index=1&id=72540ef9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72540ef9",
  null
  
)

export default component.exports